'use strict'

const CONSTANTS = require('../constants/constants');

function sendAnalyticsEvent(step, location, marketing_consent, profiling_consent) {

    let analyticsObj = {};
    if (step === 1) {
        analyticsObj.event = CONSTANTS.EVENT_CONSTANTS.NEWSLETTER_START.ID;
        analyticsObj.form_location = location;
    }

    if (step === 2) {
        analyticsObj.event = CONSTANTS.EVENT_CONSTANTS.NEWSLETTER_CONFIRM.ID;
        analyticsObj.form_location = location;
        analyticsObj.marketing_consent = marketing_consent;
        analyticsObj.profiling_consent = profiling_consent;
    }

    if (typeof dataLayer != 'undefined') {
        dataLayer.push(analyticsObj);
    }
}

module.exports = {
    sendAnalyticsEvent: sendAnalyticsEvent,
}